export default "/img/MR.36d29073d70be414cc01abc221fe704d.png";